import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormBase } from '@core/_classes/form.base';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessagesService } from '@core/_services/messages.service';
import { isInArrayKey } from '@core/_utils/tools.utils';
import { dateFormat, getComputedDate } from '@core/_utils/date.utils';

import {Message} from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'reqdetcriteria',
    templateUrl: 'reqdetcriteria.component.html',
    styleUrls: ['reqdetcriteria.component.scss'],
})
export class ReqDetCriteriaComponent extends FormBase implements OnChanges {
    @Input() public indexList;
    @Input() public propertiesList;
    @Input() public propBskList;
    @Input() public systemList;
    @Input() public criteriaData;
    @Input() public customEditorList;
    @Input()
    @Output()
    public visible: boolean;

    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();
    @Output()
    public onValid: EventEmitter<any> = new EventEmitter();

    public criteriaForm: FormGroup;
    public name = '';
    public type = '';
    public displayCustom = false;
    public currentOperator = -1;

    constructor(private formBuilder: FormBuilder, protected messageService: MessagesService,
        private translate: TranslateService) {
        super(messageService);

        this.initialization();

        this.criteriaForm = this.formBuilder.group({
            Name: null,
            Label: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(255)]],
            DefaultValue: null,
            Operat: [null, [Validators.required]],
            Editor: null,
            Visible: null,
            Search: null,
            noligne: null,
            Type: null,
            DisplayDefault: null,
        });
    }

    public ngOnInit() {}

    public ngOnChanges() {
        if (this.criteriaData) {
            this.displayCustom = false;
            this.currentOperator = this.criteriaData.Operat;
            let wRes = this.initResDate();
            wRes = this.verifyDateValue(this.criteriaData, false);
            if (wRes.res === true) {
                this.criteriaData.DefaultValue = wRes.value;
            }
            this.criteriaForm.patchValue(this.criteriaData);
            this.name = this.criteriaData.Name;
            this.type = this.criteriaData.Type;
            this.displayCustom = true;
        }
    }

    public closeDia(event) {
        this.onClose.emit('close');
    }

    public validItem() {
        const error: Array<Message> = [];
        if (this.criteriaForm.invalid) {
            this.getErrorsInputs(error, this.criteriaForm);
        } else {
            if (this.verifyInput() === false) {
                return;
            }
            if (this.criteriaData.Operat === 4 || this.criteriaData.Operat === 5) {
                this.emitValue(this.criteriaForm.value.Type);
            } else {
                // Ancien opérateur type in : on remet le type original
                if (this.currentOperator === 4 || this.currentOperator === 5) {
                    this.emitValue(this.criteriaData.Type);
                } else {
                    this.emitValue(this.criteriaForm.value.Type);           
                }
            }
        }
    }

    private emitValue(aType) {
        this.onValid.emit({
            DefaultValue: this.criteriaForm.value.DefaultValue,
            DisplayDefault: this.criteriaForm.value.DisplayDefault,
            Label: this.criteriaForm.value.Label,
            Name: this.criteriaForm.value.Name,
            Operat: this.criteriaForm.value.Operat,
            Search: this.criteriaForm.value.Search,
            Type: aType,
            Visible: this.criteriaForm.value.Visible,
            noligne: this.criteriaForm.value.noligne
        });            
    }

    private verifyInput() {
        if (
            (this.criteriaData.Type === 'DateTime' || this.criteriaData.Type === 'Date') &&
            this.validDate() === false
        ) {
            return false;
        }
        this.criteriaForm.value.Type = this.type;
        return true;
    }

    public getFieldValue(aName) {
        return this.criteriaForm.get(aName).value;
    }

    public onChangeDate(event) {
        this.criteriaData.DefaultValue = event.value;
    }

    public onChangeOperator(event) {
        this.criteriaData.Operat = event.value;
        if (this.criteriaData.Type === 'TextArea') {
            if (this.criteriaData.Name.substring(0, 4) === 'sys_') {
                this.criteriaData.Type = this.getOriginalType(this.systemList, this.criteriaData);
            } else {
                if (this.criteriaData.Name.substring(0, 5) === '&doc_') {
                    this.criteriaData.Type = this.getOriginalType(this.propertiesList, this.criteriaData);
                } else {
                    if (this.criteriaData.Name.substring(0, 5) === '&bsk_') {
                        this.criteriaData.Type = this.getOriginalType(this.propBskList, this.criteriaData);
                    } else {
                        this.criteriaData.Type = this.getOriginalType(this.indexList, this.criteriaData);
                    }
                }
            }
        }
    }

    // Récupération du type de la variable (l'opérateur in not in change le type)
    private getOriginalType(aList, aCriteriaData) {
        let wIndex = -1;
        wIndex = aList.findIndex((item) => item.Name === aCriteriaData.Name);
        if (wIndex !== -1) {
            return aList[wIndex].Type;
        } else {
            return aCriteriaData.Type;
        }
    }

    private validDate() {
        let wRes = this.initResDate();
        if (this.criteriaData.DefaultValue === 'TInDate') {
            this.criteriaData.DefaultValue = dateFormat(getComputedDate('TNow'), 'dd/MM/yyyy');
        }
        wRes = this.verifyDateValue(this.criteriaData, true);
        if (wRes.res === false) {
            this._messageService.addErrorNoStick(this.translate.instant('Op_Date'));
        } else {
            this.criteriaData.DefaultValue = wRes.value;
            this.criteriaForm.value.DefaultValue = this.criteriaData.DefaultValue;
        }
        return wRes.res;
    }

    private verifyDateValue(aCriteriaData, aInternal) {
        let wRes = this.initResDate();
        let wDate = '';
        let wTest = '';
        if (
            (aCriteriaData.Type === 'DateTime' || aCriteriaData.Type === 'Date') &&
            !isInArrayKey(aCriteriaData.DefaultValue, aCriteriaData.ListActionDate, 'value')
        ) {
            if (aInternal === true) {
                let wtest = aCriteriaData.DefaultValue.split('/');
                wtest = wtest.reverse();
                wDate = wtest[0] + '-' + wtest[1] + '-' + wtest[2];
            } else {
                wDate = aCriteriaData.DefaultValue;
            }
            let wDt = new Date(wDate);
            if (aInternal === true) {
                wTest = dateFormat(wDt, 'yyyy-MM-dd');
            } else {
                wTest = dateFormat(wDt, 'dd/MM/yyyy');
            }
            if (wTest === 'Date invalide') {
                wRes.value = wTest;
            } else {
                wRes.res = true;
                wRes.value = wTest;
            }
        } else {
            wRes.res = true;
            wRes.value = aCriteriaData.DefaultValue;
        }
        return wRes;
    }

    private initResDate() {
        let wRes: any;
        wRes = new Object();
        wRes = {
            res: false,
            value: '',
        };
        return wRes;
    }

    private initialization() {
        this.keys = {
            Label: {
                label: this.translate.instant('Crit_1'),
                pattern: '',
            },
            Operat: {
                label: this.translate.instant('Operat'),
                pattern: '',
            },
        };
    }
}
